// Scouting cues for opponent batters in the Box Score: a graduated "heat" scale by season AVG
// (hotter color = more dangerous hitter) plus formatting/correlation helpers. Tier thresholds match
// the product spec; the lowest band is gray (not white) so it stays visible on the white box score,
// and a minimum-AB gate keeps a tiny-sample fluke (a 2-for-2 cameo) from being painted "elite."

export const MIN_RATED_AB = 10;

export type HitterTier = "neutral" | "cold" | "green" | "yellow" | "orange" | "red";

export function hitterTier(avg: number, ab: number): HitterTier {
  if (!Number.isFinite(avg) || ab < MIN_RATED_AB) return "neutral";
  if (avg < 0.1) return "cold";
  if (avg < 0.2) return "green";
  if (avg < 0.3) return "yellow";
  if (avg < 0.4) return "orange";
  return "red";
}

// Baseball convention: three decimals, drop the leading zero (.429), but keep it for 1.000+.
export function formatRate(value: number): string {
  if (!Number.isFinite(value)) return "—";
  const s = value.toFixed(3);
  return s.startsWith("0.") ? s.slice(1) : s;
}

// first name + last initial — the only identity that survives both scorebooks. Our own book stores
// opponents with a last initial only ("Jack P"); the opponent's own book / season-stats has the full
// name ("Jack Pray"). Jersey numbers differ between books, so they can't be used to correlate.
export function hitterNameKey(firstName?: string, lastName?: string): string {
  const first = (firstName ?? "").trim().toLowerCase();
  const lastInitial = (lastName ?? "").trim().charAt(0).toLowerCase();
  return `${first}|${lastInitial}`;
}
